import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContactIconBlue = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 20,
			fill: "#BAE7FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.64 23.97C24.71 23.79 24 22.98 24 22C24 21.86 24.02 21.71 24.05 21.58C22.99 20.6 21.57 20 20 20C18.43 20 17.01 20.6 15.95 21.58C15.98 21.71 16 21.86 16 22C16 22.98 15.29 23.79 14.36 23.97C14.35 23.99 14.34 24 14.34 24.02C16.39 24.19 18 25.9 18 28H22C22 25.9 23.61 24.19 25.66 24.02C25.66 24 25.65 23.99 25.64 23.97Z",
			stroke: "#1677ff",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20 20C21.6569 20 23 18.6569 23 17C23 15.3431 21.6569 14 20 14C18.3431 14 17 15.3431 17 17C17 18.6569 18.3431 20 20 20Z",
			stroke: "#1677ff",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 24C23.79 24 22 25.79 22 28C22.01 28 30 28 30 28C30 25.79 28.21 24 26 24Z",
			stroke: "#1677ff",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 24C27.1046 24 28 23.1046 28 22C28 20.8954 27.1046 20 26 20C24.8954 20 24 20.8954 24 22C24 23.1046 24.8954 24 26 24Z",
			stroke: "#1677ff",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 24C11.79 24 10 25.79 10 28C10.01 28 18 28 18 28C18 25.79 16.21 24 14 24Z",
			stroke: "#1677ff",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 24C15.1046 24 16 23.1046 16 22C16 20.8954 15.1046 20 14 20C12.8954 20 12 20.8954 12 22C12 23.1046 12.8954 24 14 24Z",
			stroke: "#1677ff",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgContactIconBlue;
